import React from "react";
import ReactDOM from "react-dom";
import myimg from "./images/me.jpg";
import Typical from "react-typical";
import { NavLink} from "react-router-dom";

import "./index.css";

const About = () => {
  return (
    <>
      <section className="about" id="about">
        <div className="max-width">
          <h2 className="title">About Me</h2>
          <div className="about-content">
            <div className="column left">
              <img src={myimg} alt="" />
            </div>
            <div className="column right">
              <div className="text">
                I'm Sakshat {'&'} I'm a <span className="typing-effect">
                <Typical
                  loop={Infinity}
                  wrapper="b"
                  steps={["Programmer", 2000, "Developer", 2000, "Designer", 2000 , "Learner" , 2000]}
                ></Typical>
                </span>
              </div>
              <p>
                Hello! I’m Sakshat Mali, a passionate Software Engineer @ Adobe. With a Bachelor’s in Computer Science from IIIT Delhi, I thrive on innovation and love crafting cutting-edge applications, immersive games, and dynamic websites.<br/><br/>

                My journey is driven by a strong background in machine learning and AI, tackling complex challenges with enthusiasm. I also excel in competitive programming, earning impressive ratings on top coding platforms.<br/><br/>

                When I’m not coding, you’ll find me strategizing in chess, diving into Valorant, or enjoying music that fuels my creativity. I'm always eager to learn and explore new ideas. Let’s connect and create something extraordinary together!<br/><br/>
              </p>
              <NavLink to="/skill" className="menu-btn">
                My Skills
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
